import axios from '../request/http';
import {toFormData} from '../common/descriptions'

const goods = {
    // 获取城市列表
    cityList(params) {
        return axios.get("/hemei-admin/goods/zone/city/list", {params});
    },
    // 平台商品列表
    goodsList(params) {
        return axios.get("/hemei-admin/goods/info/villageGoods/list", {params});
    },
    // 商品详情
    goodsDetail(params) {
        return axios.get("/hemei-admin/goods/info/detail", {params});
    },
    // 专区列表
    zoneList(params) {
        return axios.get("/hemei-admin/goods/zone/zoneList", {params});
    },
    // 专区商品列表
    zoneGoodsList(params) {
        return axios.get("/hemei-admin/goods/zone/zoneGoodsList", {params});
    },
    // 专区可添加商品
    getZoneGoodsList(params) {
        return axios.get("/hemei-admin/goods/zone/getZoneGoodsList", {params});
    },
    // 商品分类列表
    categoryListAll(params) {
        return axios.get("/hemei-admin/category/listAll", {params});
    },
    // 新增修改分类
    categoryEdit(data) {
        return axios.post("/hemei-admin/category/edit", data );
    },
    // 商品标签列表
    categoryLabelList(params) {
        return axios.get("/hemei-admin/category/labelList", {params});
    },
    // 新增修改标签
    categoryLabelAdd(data) {
        return axios.post("/hemei-admin/category/labelAdd", data );
    },
    // 获取专区已添加标签
    getZoneLabel(params) {
        return axios.get("/hemei-admin/goods/zone/getZoneLabel", {params});
    },
    // 商品规格新增
    specAdd(data) {
        return axios.post("/hemei-admin/goods/info/spec/add", data );
    },
    // 商品上下架
    goodsStatus(data) {
        return axios.post("/hemei-admin/goods/info/update/status", toFormData(data) );
    },
    // 批量上下架
    goodsBatchStatus(data) {
        return axios.post("/hemei-admin/goods/info/batch/update/status", toFormData(data) );
    },
     // 批量删除
    goodsBatchDelete(data) {
        return axios.post("/hemei-admin/goods/info/batch/delete/delete", toFormData(data) );
    },
    // 商品新增/编辑
    goodsAddGoods(data) {
        return axios.post("/hemei-admin/goods/info/addGoods", data );
    },
    // 新增/修改专区
    goodsAddZone(data) {
        return axios.post("/hemei-admin/goods/zone/addZone", data );
    },
    // 专区商品新增
    zoneGoodsAdd(data) {
        return axios.post("/hemei-admin/goods/zone/zoneGoodsAdd", toFormData(data) );
    },
    // 专区商品移除
    zoneGoodsDel(data) {
        return axios.post("/hemei-admin/goods/zone/zoneGoodsDel", toFormData(data) );
    },
    // 专区商品上下架
    updateZoneGoods(params) {
        return axios.get("/hemei-admin/goods/zone/updateZoneGoods", {params} );
    },
    // 服务内容列表
    provideServiceList(params) {
        return axios.get("/hemei-admin/category/get/provideService", {params});
    },
    // 服务内容新增修改
    provideServiceAdd(data) {
        return axios.post("/hemei-admin/category/provideService", data );
    },
    // 删除服务内容、
    provideServiceDel(data) {
        return axios.post("/hemei-admin/category/del/provideService", toFormData(data) );
    },
    
}

export default goods;



// WEBPACK FOOTER //
// ./src/api/goods.js